import React, { Component } from 'react';
import SWelcomeBonus from 'shared/screens/WelcomeBonus';
import theme from 'shared/assets/style/theme';
import './WelcomeBonus.scss';
import responsiveFontSize from '../../lib/responsiveFontSize';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';

export default class WelcomeBonus extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-WelcomeBonus',
    };
  }

  render() {
    const _overlayStyle = {
      position: 'fixed',
      width: '100%',
      height: '100%',
      left: '0px',
      top: '0px',
      zIndex: 10,
    };
    return (
      <SWelcomeBonus
        navigation={this.props.navigation}
        render={args => {
          const { bonusAmount, clickHandler } = args;
          return (
            <>
              <div onClick={clickHandler} style={_overlayStyle}></div>
              <div qa-id="welcomeBonus" className={'ModalBackground'}>
                <img
                  src={require(asset`images/Welcome_Bonus_Assets/Welcome_Bonus_web.png`)}
                  alt="Welcome dialog"
                  style={{ height: '100%', width: '100%' }}
                />
              </div>
              <div className="offerDetails">
                <div
                  className="coinContainer"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <img
                    src={require(asset`images/Top_Bar_Assets/Coin_Icon@3x.png`)}
                    className="coinIcon"
                    alt="Coin Icon"
                    style={{
                      width: '2.8%',
                      alignSelf: 'center',
                    }}
                  />
                  <span
                    className={`coinAmountGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                    style={{
                      textShadow: `2px 2px 4px ${theme.palette.common[0]}`,
                      fontWeight: 600,
                      marginLeft: '0.4em',
                      alignSelf: 'center',
                      fontSize: responsiveFontSize(16, 28),
                    }}
                    data-label={bonusAmount}
                  >
                    {bonusAmount}
                  </span>
                </div>
              </div>
            </>
          );
        }}
      />
    );
  }
}

WelcomeBonus.hideCloseButton = true;
WelcomeBonus.hideDefaultBackground = true;

